import api from '../api/ramses'

const getMercuryBankslips = async () => {
  try {
    return await api.get('/integration/order/bankslip/')
  } catch (err) {
    return err.response
  }
}

const getMercuryRecurrence = async () => {
  try {
    return await api.get('/integration/order/recurrence/')
  } catch (err) {
    return err.response
  }
}

const getMercuryTransactions = async () => {
  try {
    return await api.get('/integration/order/transaction/')
  } catch (err) {
    return err.response
  }
}

export {
  getMercuryBankslips,
  getMercuryRecurrence,
  getMercuryTransactions,
}
